import { useState, useCallback, useEffect } from 'react';

import { PardotApi } from '../utils/pardotApi';
import { REGEX_EMAIL } from '../utils/regex';
import { useLanguage } from './useLanguage';

export const useNewsletter = () => {
  const initialState = {
    isError: false,
    isLoading: false,
    isSubscribed: false,
    isValidEmail: false,
    email: ''
  };

  const [newsletterData, setNewsletterData] = useState(initialState);

  const { langKey, getLanguageFromLangKey } = useLanguage();

  const isValidEmail = (email) =>
    email && email != null && email.length > 0 && REGEX_EMAIL.test(email);

  const subscribeToNewsletter = useCallback(() => {
    setNewsletterData((prevState) => ({
      ...prevState,
      isLoading: true
    }));

    PardotApi.newsletter(
      newsletterData,
      getLanguageFromLangKey(langKey).toUpperCase()
    )
      .then((res) => {
        setNewsletterData((prevState) => ({
          ...prevState,
          isLoading: false,
          isSubscribed: true
        }));
      })
      .catch((err) => {
        console.log(err);

        setNewsletterData((prevState) => ({
          ...prevState,
          isLoading: false
        }));
      });
  }, [newsletterData]);

  useEffect(() => {
    setNewsletterData((prevState) => ({
      ...prevState,
      isValidEmail: isValidEmail(newsletterData.email)
    }));
  }, [newsletterData.email]);

  return { newsletterData, setNewsletterData, subscribeToNewsletter };
};
